<!--  -->
<template>
    <el-pagination prev-text="上一页" next-text="下一页" @current-change="currentChange" background layout="prev, pager, next" :page-size="page.pageSize" :current-page="page.page" :total="page.total"></el-pagination>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: ['page'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        currentChange(page) {
            this.page.page = page
            this.$emit('currentChange', this.page)
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .el-pagination {
        .btn-prev, .btn-next {
            width: 62px;
        }
    }
</style>